const EntryBillComponent = () => import('@/views/WareHouse/EntryBill/EntryBillView')

export default [
    {
        path:'/EntryBillIndex',
        name:'EntryBillComponent',
        component:EntryBillComponent
    }
]